export const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Bottom container */}
    <path d="M3 15c0 2.83 0 4.24.88 5.12C4.76 21 6.17 21 9 21h6c2.83 0 4.24 0 5.12-.88C21 19.24 21 17.83 21 15" />

    {/* Arrow */}
    <path d="M12 3v13M12 16l4-4.375M12 16l-4-4.375" />
  </svg>
);
